<template>
  <section>
    <sweet-modal ref="modal"
                 overlay-theme="dark"
                 blocking
                 :enable-mobile-fullscreen="false">
      <template v-if="userVerification">
        <img v-lazy="userVerification.line_image_url" alt="" class="img-fluid">
        <div class="text-left my-4">{{ userVerification.line_description }}</div>
        <div>
          <a href=""
             target="_blank"
             class="btn btn-success"
             @click.prevent="addLine(userVerification.line_login_url)">GET LINE DISCOUNT</a>
        </div>
        <div class="mt-4">
          <a href=""
             @click.prevent="skipAddingLine">Skip</a>
        </div>
      </template>

    </sweet-modal>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SweetModal
    },
    data () {
      return {}
    },
    computed: {
      ...mapState('user', ['userVerification'])
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      },
      addLine (url) {
        window.open(url, '_blank')
        this.closeModal()
      },
      skipAddingLine () {
        this.$store.commit('user/SET_SKIP_ADDING_LINE', true)
        this.closeModal()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/LineVerificationModal.vue